var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moor-switch"},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('div',{class:[{closed: !_vm.checked}, 'switch-box'],on:{"click":function($event){return _vm.handleChange(_vm.value)}}},[_c('span',{class:{closed: !_vm.checked}})]),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","true-value":_vm.activeValue,"false-value":_vm.inactiveValue,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e00f2a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/switch/switch.vue
// module id = 10
// module chunks = 0